import React from 'react'

import { WarnerLogoText } from '../../../constants/constants';

import Heading from "../../../shared/Heading/Heading";

const TextLogo = () => {
  return (
    <Heading 
        txt={WarnerLogoText}
        new_styles={{
            fontSize: "1.3rem",
            color: "#4b5781"
        }}
    />
  )
}

export default TextLogo